import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	consultaProcessoAdministrativoSuccess,
	consultaProcessoAdministrativoFailure,
} from './actions';

function* consultaProcessoAdministrativoRequest(request: ReducerAction) {
	const { payload } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`processos-administrativos/${CHANNEL}/processos-administrativos`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaProcessoAdministrativoSuccess(response));
	} else {
		yield put(consultaProcessoAdministrativoFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_PROCESSO_ADMINISTRATIVO_REQUEST,
		consultaProcessoAdministrativoRequest,
	),
]);
